var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.iconData),function(iconItem,index){return _c('div',{key:index},[_c('p',{style:({ color: 'var(--textColor)' })},[_vm._v(_vm._s(iconItem.name))]),_c('div',{staticClass:"fill_icon_box"},_vm._l((iconItem.data),function(className,index){return _c('div',{key:index,staticClass:"swpier_botton_icon_box"},[_c('span',{class:[
                  className,
                  'swpier_botton_icon',
                  _vm.selectedIcon === className && 'active_swiper_button'
                ],style:({
                  '--color': _vm.request_prefix.toLowerCase().includes('stage')
                    ? 'rgba(0, 0, 0, 0.8)'
                    : 'rgba(255, 255, 255, 0.4)'
                }),on:{"click":function($event){return _vm.changeIconClassName(className)}}})])}),0)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }